<ui-loader class="loader" *ngIf="loading"></ui-loader>

<div [class.loading]="loading">
  <div class="header label-sm-semibold">{{ 'signals-ng-visualization-tab.visualizationViews.worldMap' | translate | titleCase }}</div>
  <div uiHotspot="worldmapVisualization">
    <div uiHotspot="worldmapVisualizationType">
      <chart-worldmap
        [data]="data"
        [scale]="scale"
        (worldmapTypeChanged)="worldmapTypeChanged($event)"
        (trackEvent)="trackEvent($event)"
        [(countrySelectModel)]="countriesModel"
        (countrySelectModelChange)="countrySelected($event)"
        [categoryKey]="insightsType.DOCUMENT_TYPE"
        [excluded]="countriesExcluded"
      ></chart-worldmap>
    </div>
  </div>
</div>
